export const STR_ERRORS = {
    NoConnectionsAvailable: "No connection class was found, did you initialize the data layer?",
    WrongTypeForQuerySet: "Assigning the wrong query value! Queries can only be of type SDQuery<T>.",
    SDQRequestFormatRequiresActiveQuery: "SDQRequestFormatRequiresActiveQuery",
    ReachedTimeLimitForOpeningConnection: "Reched the time limit for openning a connection",
    NoMessageBus: "Wrong configuration! Please provide the message bus",
    NoConnectionUrls: "Wrong configuration! Please provide connection URLs",
};
export const STR = {};
//# sourceMappingURL=index.js.map